import { __assign } from "tslib";
import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import { BError } from './BError';
import { BLayout } from '../BLayout';
import { useField } from 'formik';
/**
 * **Must be a child of BForm**
 *
 * The `BEmail` is to be used for any email field
 *
 *  **Required Props:**
 *  - name
 *      - Must match the name from initialValues
 *
 * **Optional Props:**
 * - [TextFieldProps](https://material-ui.com/api/text-field/#props)
 *  - almost any Material-UI props
 * - [BLayout](https://gitlab.com/2020-bootcamp/forms/mui-bueno/-/blob/update-docs/documentations/tag-references/MWidget.md)
 *  - custom gridding, sizes, and alignment
 * - required
 *  - default is false, if true the field will be required.
 * - placeholder
 *  - the short hint displayed in the input before the user enters a value.
 * - label
 *  - the label content.
 * - regExp
 *  - the regular expression to validate the email with (default is [letters/nums]@[letters/nums].[letters/.s/numbers]).
 *
 * **Basic Example:**
 * ```jsx
 * <BEmail
 *   name="email"
 *   label="Email"
 *   placeholder="Enter email"
 *   textFieldProps={{
 *      variant: 'outlined',
 *      margin: 'dense'
 *    }}
 * />;
 * ```
 *
 * Demos:
 *
 * - [Sample Form](https://material-ui.com/components/text-fields/)
 *
 * API:
 *
 * - [BEmail API](https://gitlab.com/2020-bootcamp/forms/mui-bueno/-/blob/update-docs/docs/tag-references/input/BEmail.md)
 */
export var BEmail = function (props) {
    var name = props.name, _a = props.w, w = _a === void 0 ? 2 : _a, _b = props.required, required = _b === void 0 ? false : _b, _c = props.regExp, regExp = _c === void 0 ? /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/ : _c, _d = props.placeholder, placeholder = _d === void 0 ? 'Enter email' : _d, _e = props.label, label = _e === void 0 ? 'Email' : _e, className = props.className;
    // Formik boilerplate ------------------
    var _f = useField({ name: name, validate: function () { return validation(); } }), field = _f[0], meta = _f[1];
    var value = field.value;
    var error = meta.error, touched = meta.touched;
    // -------------------------------------
    //Validation for formatted 
    var validation = function () {
        if (!value) {
            return required ? label + " is required" : '';
        }
        var str = value;
        // If its not required and its empty, or its filled and correct format, its ok
        if ((!required && !value) || regExp.test(str.toLowerCase())) {
            return '';
        }
        else {
            return "Invalid email format";
        }
    };
    return (React.createElement(BLayout, __assign({}, props, { w: w }),
        React.createElement("div", { className: className },
            React.createElement(TextField, __assign({ label: label, margin: 'dense', variant: 'outlined', id: name + "-tf", type: 'input', autoComplete: 'email', fullWidth: true }, props.textFieldProps, field, { error: Boolean(error) && touched, placeholder: placeholder })),
            React.createElement(BError, { name: name, id: name + "-err" }))));
};
//# sourceMappingURL=BEmail.js.map